<template>
    <transition name="modal">
        <div v-if="element && !isLoading" class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="container">
                        <div class="modal-header">
                            <div class="row">
                                <div class="col-8">
                                    <h1 v-text="element.$exists ? 'Edit Zip Code' : 'Add Zip Code'"></h1>
                                </div>
                                <div class="col-auto ml-auto">
                                    <div class="modal-default-button fa fa-window-close d-print-none" @click="$emit('close')"></div>
                                </div>
                            </div>
                        </div>

                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Zip Code <span class="required">*</span></label>
                                        <input class="form-control" type="text" v-model="element.zip_code">
                                        <div class="alert alert-danger" v-if="'zip_code' in errors" v-text="errors.zip_code.join()"></div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>City <span class="required">*</span></label>
                                        <input class="form-control" type="text" v-model="element.city">
                                        <div class="alert alert-danger" v-if="'city' in errors" v-text="errors.city.join()"></div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>State <span class="required">*</span></label>
                                        <states v-slot="{ states }" :params="{}">
                                            <select class="form-control" v-model="element.state_id">
                                                <option v-for="state in states" :key="state.id" :value="state.id" v-text="state.name"></option>
                                            </select>
                                        </states>
                                        <div class="alert alert-danger" v-if="'state' in errors" v-text="errors.state.join()"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label>Zip Code Page Hero Image</label>
                                    <p v-if="element.hero_image">Existing Image: {{ originalImage }}</p>
                                    <dropzone id="hero-image" ref="heroImage" url="/order/api/zip-codes/image" :maxNumberOfFiles="1" :maxFileSizeInMB="64" acceptedFileTypes=".jpg,.jpeg,.gif,.png" @vdropzone-mounted="dropzoneMounted" @vdropzone-success="setFileName"></dropzone>
                                    <input type="hidden" v-model="image" />

                                    <div class="alert alert-info">Images will be resized down so they will not exceed 300px tall.</div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between d-print-none">
                                <delete-button v-if="element.$exists" @confirmed="destroyAndClose" title="Delete Zip Code">
                                    <p>
                                        Are you sure you want to delete the zip code {{ element.name }}?
                                    </p>
                                </delete-button>
                                <div class="ml-auto">
                                    <button aria-label="Close Order Editing Modal window" class="ml-auto btn btn-medium" @click="$emit('close')">Cancel</button>
                                    <button class="btn btn-primary" @click="saveAndClose" v-text="element.$exists ? 'Update' : 'Save'"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { ContinuousCollectionComponent, ElementComponent } from 'clockvine-vue';
import Dropzone from 'vue2-dropzone';
import deleteButton from './DeleteButton';
import ElementOperations from './helpers/ElementOperations';

export default {
    props: ['id'],

    components: {
        Dropzone, 
        deleteButton,
        states: ContinuousCollectionComponent.for("states")
    },

    mixins: [
        ElementComponent.for("zipCodes").with({
            computed: {
                newElement: () => ({})
            }
        }),
        ElementOperations,
    ],

    data: () => ({
        originalImage: '',
        image: null,
        files: [],
    }),

    created() {
        this.$store.dispatch('states/index');
    },

    mounted () {
        this.originalImage = this.element?.image_path;
        if (this.element && this.element.image_path && !this.element.hero_image) {
            this.element.hero_image = this.element.image_path.replace(/.*\//, '');
            this.image = this.element.hero_image;
        }

        if (this.element && this.element.$exists && this.element.hero_image) {
            this.image = this.element.hero_image;
        }
    },
    
    unmounted() {
        this.image = '';
    },

    methods: {
        dropzoneMounted() {
            this.populateDropzone();

            this.$refs.heroImage.dropzone.on('addedfile', function (file) {
                if (this.files.length > 1) {
                    this.removeFile(this.files[0]);
                }
            });
            this.$refs.heroImage.dropzone.on('maxfilesexceeded', function (file) {
                this.removeFile(file);
            });
            this.$refs.heroImage.dropzone.on('removedfile', this.clearFileName);
        },

        'setFileName': function (file) {
            const filename = file.name.toLowerCase();
            this.image = filename;
        },

        'clearFileName': function() {
            this.image = '';
        },

        saveAndClose() {
            this.element.hero_image = this.image;
            this.save().then(() => {
                this.$emit('reindex');
                this.$emit('close');
            });
        },

        destroyAndClose() {
            this.delete().then(() => {
                this.$emit('reindex');
                this.$emit('close');
            });
        },

        populateDropzone() {
            let hero_image = this.element?.hero_image;
            let image_path = this.element?.image_path;

            if (hero_image) {
                var mockFile = {
                    name: hero_image,
                    size: 12345,
                    status: Dropzone.ADDED,
                    url: image_path
                };

                 // Call the default addedfile event handler
                this.$refs.heroImage.dropzone.emit("addedfile", mockFile);

                // And optionally show the thumbnail of the file:
                this.$refs.heroImage.dropzone.emit("thumbnail", mockFile, image_path);

                this.$refs.heroImage.dropzone.emit("complete", mockFile);

                this.$refs.heroImage.dropzone.files.push(mockFile);
            }
        },
    },
}
</script>
